export default __webpack_public_path__ + "static/media/Product Page Black - Front Outside-03900-2-sq.ab2c2879.webp";